import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getUserService, loginService } from "../api/UserApi";
import { useNavigate } from "react-router";
import { checkPayUser } from "../api/UserApi";

// Hook to read auth data directly from cache
export const useAuthData = () => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData(["auth"]) || { token: null, isAuthenticated: false };
};

export const useAuth = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  
  const {
    data: userData,
    isLoading: isUserLoading,
    isError: isUserError,
    refetch: refetchUserData,
  } = useQuery({
    queryKey: ["user-data"],
    queryFn: () => getUserService(),
    // enabled: false,
  });
  const syncAuthFromStorage = async () => {
    const token = localStorage.getItem("token");
    queryClient.setQueryData(["auth"], {
      token,
      isAuthenticated: !!token,
    });
  };
  const loginMutation = useMutation({
    mutationFn: async (data) => {
      try {
        return await loginService(data);
      } catch (error) {
        // Return error object with status and message for component to handle
        if (error.response) {
          const { status, data: responseData } = error.response;
          throw {
            status,
            message: responseData?.error || error.message,
            responseData
          };
        }
        throw error;
      }
    },
    onSuccess: async (data) => {
      // Check if OTP is required
      if (data?.require_otp) {
        // Navigate to OTP verification page
        navigate(`/auth/verify-otp?email=${encodeURIComponent(data.email)}`, {
          replace: true,
          state: { 
            email: data.email,
            requireOtp: true
          }
        });
        return;
      }

      if (data?.access_token && data?.user) {
        if (data.access_token) {
          localStorage.setItem("token", data.access_token);
        } else {
          localStorage.removeItem("token");
        }
        queryClient.invalidateQueries(["user-data"]);
        const authenticated = {
          token: data.access_token,
          isAuthenticated: true,
        };
        queryClient.setQueryData(["auth"], authenticated);
        navigate("/agent", { replace: true });
      } else {
        console.error(
          "Login successful response missing access_token or user:",
          data
        );
        throw new Error("Invalid response structure from server.");
      }
    },
    onError: (error) => {
      // Error is already handled in mutationFn, just re-throw
      throw error;
    },
  });
  return {
    login: loginMutation.mutateAsync,
    syncAuthFromStorage,
    userData,
    refetchUserData,
    isUserLoading,
    isUserError,
  };
};

export const useCheckPayUser = (uID) => {
  return useQuery({
    queryKey: ["pay", uID],
    queryFn: () => checkPayUser(uID),
    enabled: !!uID,
  });
};
